import { jsxs as r, jsx as l } from "react/jsx-runtime";
import { E as v, S as m } from "./icons.types-0722eef5.js";
function g({ title: t, titleId: c, size: a, width: i, height: n, extended: o = !1, ...s }) {
  const h = o ? v : m, e = a ? h[a] : i || h[o ? "s" : "l"], d = a ? h[a] : n || h[o ? "s" : "l"];
  return /* @__PURE__ */ r(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: e,
      height: d,
      "aria-labelledby": c,
      ...s,
      children: [
        t ? /* @__PURE__ */ l("title", { id: c, children: t }) : null,
        /* @__PURE__ */ r(
          "g",
          {
            fill: "currentColor",
            clipPath: "url(#Bluetooth__Brand_svg__a)",
            children: [
              /* @__PURE__ */ l("path", { d: "M54.41 62.295h.415a.565.565 0 0 0 .385-.12.416.416 0 0 0 .145-.335c0-.3-.19-.465-.53-.465h-.415v.92Zm.86 1.18-.53-.94h-.33v.965h-.305v-2.34h.79a.896.896 0 0 1 .31.05c.09.035.173.086.245.15.067.064.121.14.16.225.04.086.061.18.06.275a.636.636 0 0 1-.14.41.685.685 0 0 1-.36.25l-.1.035.55.945-.35-.025Zm-.5-3.085a1.94 1.94 0 0 0-.745.145 1.91 1.91 0 0 0-.6.41 2 2 0 0 0-.405.615 2.074 2.074 0 0 0 0 1.5 1.878 1.878 0 0 0 1.005 1.025 1.885 1.885 0 0 0 2.085-.41c.177-.173.315-.383.405-.615a2.075 2.075 0 0 0 0-1.5c-.092-.23-.23-.44-.405-.615a1.857 1.857 0 0 0-.6-.41 1.936 1.936 0 0 0-.74-.145Zm0 4.155a2.154 2.154 0 0 1-.865-.175c-.263-.12-.5-.29-.7-.5-.211-.2-.381-.44-.5-.705a2.215 2.215 0 0 1 0-1.725 2.27 2.27 0 0 1 1.175-1.185c.273-.116.568-.173.865-.17a2.23 2.23 0 0 1 .87.17c.264.121.503.29.705.5.208.203.378.442.5.705a2.216 2.216 0 0 1 0 1.725c-.121.264-.29.504-.5.705a2.215 2.215 0 0 1-1.575.655" }),
              /* @__PURE__ */ l("path", { d: "M36 64.675c12.5 0 21.15-5.95 21.15-28.675S48.525 7.325 36 7.325c-12.525 0-21.15 5.95-21.15 28.675S23.5 64.675 36 64.675ZM33.255 36 23 25.725l2.97-3 8.175 8.195V11.345L49 26.195 39.19 36 49 45.805l-14.85 14.85V41.08L26 49.25l-2.97-3L33.255 36Zm5.065 14.5 4.74-4.745-4.74-4.735v9.48Zm0-29.03 4.74 4.745-4.74 4.735v-9.48Z" })
            ]
          }
        ),
        /* @__PURE__ */ l("defs", { children: /* @__PURE__ */ l("clipPath", { id: "Bluetooth__Brand_svg__a", children: /* @__PURE__ */ l(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  g as BluetoothBrand
};
